import React from 'react';

const Form = props =>
	<form onSubmit={onSubmit.bind(null, props)}>
		{props.children}
	</form>;

function onSubmit(props, event) {
	props.onSubmit();
	event.preventDefault();
}

export default Form;

const Field = ({ children }) =>
	<div>
		{children}
	</div>;



// WEBPACK FOOTER //
// ./src/js/utils/Form.js